import { render, staticRenderFns } from "./FeatureCheck.vue?vue&type=template&id=45de5ec4"
import script from "./FeatureCheck.vue?vue&type=script&lang=js"
export * from "./FeatureCheck.vue?vue&type=script&lang=js"
import style0 from "./FeatureCheck.vue?vue&type=style&index=0&id=45de5ec4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports